import { render, staticRenderFns } from "./CustomDrawer.vue?vue&type=template&id=bbb69372"
import script from "./CustomDrawer.vue?vue&type=script&lang=js"
export * from "./CustomDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports